<ng-container *transloco="let t;">
    <div class="content-header">
        <h1 class="mb-0">
            {{t('Onboarding form step how to plan use simpleSign heading on onboarding page (How are plannig to
            use the
            system) How are you planning to use SimpleSign?')}}
        </h1>
        <p class="subtitle-text">
            {{t('Onboarding planned use reason text - This allows us to tailor your experience and
            communications')}}.
        </p>
    </div>

    <div class="form-group">
        <div class="button-options-container">
            <button type="button" class="option-button"
                (click)="onPlanningToUseSelect('for_work')">
                <img src="assets/images/pages/onboarding/buildings.png" alt="for work icon"
                    class="button-icon-for-work">
                <div class="button-text-container">
                    <div class="main-option-button-text">
                        {{t('for work radio button label on onboarding page (for work radio button label) For
                        work')}}
                    </div>
                    <div class="option-button-subtitle-text">
                        {{t('for work description (Onboarding form) - Draft, review, and monitor contracts')}}
                    </div>
                </div>
            </button>

            <button type="button" class="option-button"
                (click)="onPlanningToUseSelect('for_personal_projects')">
                <img src="assets/images/pages/onboarding/house.png" alt="for personal icon" class="button-icon">
                <div class="button-text-container">
                    <div class="main-option-button-text">
                        {{t('For personal projects radio button label on onboarding page (For personal projects
                        radio button
                        label) For personal projects')}}
                    </div>
                    <div class="option-button-subtitle-text">
                        {{t('for personal projects description (Onboarding form) - Prepare, sign, and track
                        contracts')}}
                    </div>
                </div>
            </button>

            <button type="button" class="option-button"
                (click)="onPlanningToUseSelect('for_freelance_projects')">
                <img src="assets/images/pages/onboarding/frame.png" alt="for freelancing icon"
                    class="button-icon">
                <div class="button-text-container">
                    <div class="main-option-button-text">
                        {{t('For freelancing projects radio button label on onboarding page (For freelancing
                        projects button
                        label) For freelancing projects')}}
                    </div>
                    <div class="option-button-subtitle-text">
                        {{t('for freelancing projects description (Onboarding form) - Send, sign, and manage
                        freelance
                        contracts')}}
                    </div>
                </div>
            </button>

        </div>
    </div>
</ng-container>
